module.exports = __webpack_public_path__ + "static/img/info_3.620c01e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info_3.jpg
// module id = XNlA
// module chunks = 1